import { View } from 'backbone';
import template from 'designer/left-panel-filter-search.ejs';
import listService from 'ListService';
import eventBus from 'EventBus';
import toolboxItemMapService from 'ToolboxItemMapService';
import ThumbPageListView from './ThumbPageListView';
import pageTemplate from 'common-views/select-field/select-field-page.ejs';
import controlTemplate from 'common-views/select-field/select-field-control.ejs';
import pageCommandTemplate from 'common-views/select-field/select-command-page.ejs';
import commandTemplate from 'common-views/select-field/select-field-command.ejs';
import factoryService from 'FactoryService';
import BehaviorHelperService from "../../service/BehaviorHelperService";
import constants from 'Constants';
import LeftPanelStateService from '../../service/LeftPanelStateService';
import thumbPageListUtil from 'util/ThumbPageListUtil.js';
import controlBehaviorsTemplate from 'common-views/control-behaviors.ejs';
import util from 'util/Util.js';

const SILENT = constants.MODEL_SILENT;


class FilterAndSearchView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.id = opts.el;
        this.model.set('isForm', listService.docType === constants.DOC_TYPE_FORM, SILENT);
       
        this.events = {
            'change  #filtermenu': 'selectFilter',
            'keyup #searchLeftPanel': 'searchObjects'
         };
 
        this.listenTo(eventBus, constants.EV_RESTORE_FILTER_RESULT, this.restoreFilterResults);

        if (!this.model.get('filterList')) {
            this.getFilterList();
        }

        return this;
    }

    getFilterList() {
        let list = [], fl, flCommands;
        if (this.model.get('isForm')) {
            fl = toolboxItemMapService.getLayoutItemsByGroup('all');
            _.forEach(fl, (f) => {
                if (f.factoryKey !== 'control_checkbox_group' && f.factoryKey !== 'control_radio_button_group') {
                    list.push({ name: f.name, id: f.factoryKey, type: 'object' });
                }
            });

            flCommands = toolboxItemMapService.getBehaviorItemsByGroup('all');
            _.forEach(flCommands, (f) => {
                list.push({ name: f.name, id: f.factoryKey, type: 'command' });
            });
        } else {
            fl = toolboxItemMapService.getReportItemsByGroup('all');
            _.forEach(fl, (f) => {
                if (f.factoryKey !== 'control_checkbox_group' && f.factoryKey !== 'control_radio_button_group') {
                    list.push({ name: f.name, id: f.factoryKey, type: 'object' });
                }
            });

            flCommands = toolboxItemMapService.getReportBehaviorItemsByGroup('all');
            _.forEach(flCommands, (f) => {
                list.push({ name: f.name, id: f.factoryKey, type: 'command' });
            });
        }

        list.sort((a, b) => a.name.localeCompare(b.name));
        this.model.set('filterList', list, { silent: true });
    }

    searchObjects(e, keyPressed) {
        const keyCode = e.code || e.key;
        const self = this;
        if (keyCode === 'Enter' || e.keyCode === 13 || keyPressed === 13) {
            $("#filtermenu").val("none");
            this.selectedType = 'object'
                
            setTimeout(function () {
                let pageObjects = [];
                let filter = e.currentTarget.value || $("#searchLeftPanel").val();
                filter = filter.toLowerCase();

                if (filter !== "") {
                    const searchInputFilter = (control) => {
                        const factoryName = control.model.get('factoryKey').toLowerCase();
                        const controlName = control.model.get('name').toLowerCase();
                        return (control !== undefined &&
                            (factoryName.indexOf(filter) > -1 || controlName.indexOf(filter) > -1));
                    };

                    pageObjects = listService.getAllControlsByPageList(searchInputFilter, false, null, filter);
                    self.filterObjects(e, pageObjects, 'object');
                }
                else{
                    $('#filterResults').empty();
                    $('#filterResults').addClass('hide');
                }
            }, 50)
        }
    }

    selectFilter(e){

        e.preventDefault();
        // find all objects matching filter
        $("#searchLeftPanel").val("");
        
        let val = $(e.currentTarget).val();
        let option = $(`option[value=${val}]`).first();
        const selectedFilter = option.attr('data-id');
        this.selectedType = option.attr('data-type-id');

        let pageObjects = [];

        if (val !== "none") {
            if (this.selectedType === 'object') {
                let inputFilter = (control) => {
                    return (control !== undefined && control.model.get('factoryKey') === selectedFilter);
                };
                //PF-4920 Retrieve controls by page following a particular structure to be rendered in the template
                pageObjects = listService.getAllControlsByPageList(inputFilter, false, null, selectedFilter);
            }

            if (this.selectedType === 'command') {
                let inputFilter = (control) => {
                    return (control !== undefined && control.model.get('factoryKey') === selectedFilter);
                };
                // get all Commands associated by Page
                pageObjects = listService.getBehaviorInstanceObjectsByPageList(inputFilter, true, true)
            }

            this.filterObjects(e, pageObjects)
        }
        else{
            $('#filterResults').empty();
            $('#filterResults').addClass('hide');
        }
    }

    //PF-4920 Here is the main event where all the filtering logic happens on the tree.
    filterObjects(e, pageObjects) {
                
        let hasResults = false;
        $('#filterResults').empty();
        $('#filterResults').removeClass('hide');
        let self = this;
        _.forEach(pageObjects, function (page) {
            if (page.controls.length > 0) {
                hasResults = true;
                // Page Template
                page.isFilter = true;
                if (self.selectedType === 'command') {
                    page.type = 'command';
                    page.controlId = page.id;

                    $('#filterResults').append(pageCommandTemplate(page));
                    self.generateCommands(page.id, page.controls);
                } else {
                    page.type = 'control';
                    $('#filterResults').append(pageTemplate(page));
                    self.generateControls(page.id, page.controls);
                }
            }
        });

        if (!hasResults) {
            $('#filterResults').append('No Results Found');
        }

        LeftPanelStateService.saveFilterResult();

        this.bindFilteredObjectsEvents();
    }

    showList(e) {
        e.preventDefault();
        var target = e.currentTarget.getAttribute('data-target');
        var key = e.currentTarget.getAttribute('data-selected-key');
        var targetText = e.currentTarget.text.trim();

        if (target) {
            let controlListSelector = '#' + target;
           
            $(controlListSelector).slideToggle(100, () => {
                if (e.target) {
                    util.toggleIcon(e, true);
                    LeftPanelStateService.saveFilterResult();
                }
            });

            
            if (this.mode === 'objects' || this.mode === 'print'
                || this.mode === 'instance' || this.mode === 'insertField') {
                this.model.set('selected', { id: listService.getCleanedId(target), name: targetText }, { silent: true });
                $('a.field-select').removeClass('selected');
                $(target).addClass('selected');
                if (this.target === 'command_set_table_rows') {
                    $('button.btn-select-field').button({ disabled: key !== 'control_table' });
                } else {
                    $('button.btn-select-field').button({ disabled: false });
                }
            }
        }
    }

    restoreFilterResults(){

        if($("#searchLeftPanel").val() !== "" && !util.isEmpty($("#searchLeftPanel").val())){
            this.selectedType = 'object';
        }
        else if($('#filtermenu').val() !== "none"){
            this.selectedType = $('#filtermenu').find(':selected').data('type-id');
        }

        $("#filterResults").html(LeftPanelStateService.filterResult);
        this.bindFilteredObjectsEvents();
        $("#filterResults").removeClass("hide");
    }

    bindFilteredObjectsEvents(){
        let self = this;
        $(constants.SELECT_FIELD_LIST_TOGGLE).on('click', (e) => {
            e.preventDefault();
            if (e.target.localName === 'i') {
                this.showList(e);
            }
        });

        $(constants.SELECT_BEHAVIOR_ITEM_FILTER).on('click', (ev) => {
            LeftPanelStateService.save();
            let pageItemInFilter = $(ev.target).parents('a.field-list-toggle')[0];
            if (pageItemInFilter){
                thumbPageListUtil.loadTreeNodesByPageId($(pageItemInFilter).data('target'));
            }
            BehaviorHelperService.processBehaviorClickEvent(ev, this.factoryKey, this.model);            
        });

        $(constants.SELECT_FIELD_ITEM).on('click', (e) => {
            e.preventDefault();
            const pageListItem = $(e.target).parents('li.page-list')[0];
            const pageItemInFilter = pageListItem ? $(pageListItem).children("a.field-list-toggle")[0] : undefined;

            if (pageItemInFilter){
                thumbPageListUtil.loadTreeNodesByPageId($(pageItemInFilter).data('target'));
            }
            if (e.target.localName === 'i') {
                return
            }
            LeftPanelStateService.save();
            let id = e.currentTarget.attributes["data-selected-item"].value;
            if (id.includes('-')) {
                id = id.split('-')[1];
                //e.stopPropagation();
            }

            if (this.selectedType === 'object') {
                thumbPageListUtil.selectObject(id);
            }
            if (this.selectedType === 'command') {
                // navigate to instance like current link on left panel, but pass ID of command to select
                if ($(e.currentTarget).hasClass('behavior-result') ||
                    $(e.currentTarget).hasClass('control-result')) {
                    return false;
                }
                else if ($(e.currentTarget).hasClass('command-result')) {
                    let behaviorTreeId = e.currentTarget.attributes["data-selected-item"].value;
                    let ids = behaviorTreeId.split('-');
                    let behaviorId = e.currentTarget.attributes["instance-id"].value;
                    this.selectBehaviorInstanceForFilter(behaviorId, ids[2]);
                }
            }
            else {
                // navigate to instance like current link on left panel, but pass ID of command to select
                try {
                    let previousSibling = e.currentTarget.parentNode.parentNode.previousElementSibling.attributes["data-selected-item"];
                    if (previousSibling) {
                        let instanceId = previousSibling.value;
                        thumbPageListUtil.selectBehaviorInstance(instanceId, id);
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        });
    }

    selectBehaviorInstanceForFilter(id, selectedCommand = '') {
        var instance = listService.getBehaviorInstance(id);
        if (instance) {
            $('.controlSelected').removeClass('controlSelected');
            if (listService.mainKind === constants.KIND_BEHAVIORS) {
                //eventBus.trigger('behaviorInstanceShow', id);
                let $behaviorSelector = (instance.get('owner') === 'Form')
                    ? $('#behaviors-forms')
                    : $(`#behaviors-page-${listService.currentPageId}`);

                $behaviorSelector.find(`li[data-id="${id}"]`).addClass('controlSelected');
            } else {
                let command = '';
                if (selectedCommand) {
                    command = '/' + selectedCommand;
                }

                // PF-1951 Turning on flag for back-button purposes
                listService.linkClicked = true;
                Backbone.history.loadUrl('behaviors/' + instance.get('ownerId') + '/' + instance.get('behaviorKey') + command);

            }
            BehaviorHelperService.showBehaviorInstanceForFilter(id, selectedCommand);
        }
    }

    generateCommands(parentId, commands) {
        let self = this;
        let parentDOMSelector = '#filterResults ul.control-list.' + parentId;
        _.forEach(commands, function (command) {
            let isWorkflow = command.behaviorKey === "workflow";

            command.cleanOwnerId = command.ownerId !== "Form" ? listService.cleanId(command.ownerId) : command.ownerId;
            command.cleanControlId = listService.cleanId(command.controlId);

            command.isFilter = true;
            command.rootControlTooltip = '';
            let name = command.controls ? command.controls[0].name : command.ownerId;
            if (command.ownerId !== parentId && !isWorkflow) {
                let rootControl = listService.getObject(command.ownerId);
                if (!rootControl && command.isTableColumn && !isWorkflow) {
                    rootControl = listService.getObject(command.tableInfo);
                }
                const rootControlFactoryName = factoryService.factories[rootControl.model.get('factoryKey')].name;
                command.rootControlTooltip = rootControlFactoryName + ': ' + rootControl.model.get('name');
            }
            command.tooltip = `${command.name}-${name}`;
            if (self.behaviorTriggerExists(command)) {
                command.type = 'command';
                command.instanceId = command.id;
                command.id = `${command.cleanOwnerId}-${command.behaviorKey}-${command.controls[0].id}`;
                parentDOMSelector = `#filterResults ul.control-list.${command.cleanOwnerId}-${command.behaviorKey}`;
                $(parentDOMSelector).append(commandTemplate(command))
            } else if (self.controlExists(command)) {
                command.type = 'behavior';
                command.instanceId = command.id;
                command.id = `${command.cleanOwnerId}-${command.behaviorKey}`;

                if(command.behaviorKey === "workflow"){
                    const path = listService.getWorkflowPath(command.ownerId);

                    command.name = path.model.get("id");
                    command.text = path.model.get("name");

                    if(util.isEmpty(command.text) || command.text === ""){
                        command.text = "Path (Unnamed)"
                    }
                }
                parentDOMSelector = `#filterResults ul.control-list[data-selected-control='${command.behaviorKey === "workflow" ? "workflow" : command.cleanControlId}']`;
                $(parentDOMSelector).append(commandTemplate(command))
            } else {

                command.type = 'control';
               
                if(command.ownerId === "Form"){
                    command.type = 'app-behavior';
                    command.instanceId = command.id;               
                }
                 let owner = listService.getObject(command.ownerId);

                if ((owner && owner._groupId) || command.isTableColumn) {
                    let ownerParent = command.isTableColumn ? listService.getObject(command.tableInfo) : listService.getObject(owner._groupId);
                    const factoryName = factoryService.factories[ownerParent.model.get('factoryKey')].name;
                    let controlParent = {
                        id: ownerParent.model.get('id'),
                        controlId: command.isTableColumn ? command.tableInfo : ownerParent.model.get('id'),
                        factoryKey: ownerParent.model.get('factoryKey'),
                        icon: ownerParent.model.get('icon'),
                        name: ownerParent.model.get('name'),
                        selectFields: undefined,
                        isFilter: true,
                        controls: [],
                        isNested: !!ownerParent._groupId,
                        groupId: ownerParent._groupId ? ownerParent._groupId : null,
                        tooltip: (factoryName) + ' - ' + ownerParent.model.get('name')
                    };
                    if (!self.controlExists(controlParent)) {
                        self.generateControls(parentId, [controlParent], false);
                        parentDOMSelector = `#filterResults ul[control-id=${controlParent.controlId}]`;
                    } else if (command.isTableColumn) {
                        parentDOMSelector = `#filterResults ul.control-list[data-selected-control="${controlParent.controlId}"]`;
                    } else {
                        parentDOMSelector = `#filterResults ul[control-id=${controlParent.id}]`;
                    }
                } else {
                    parentDOMSelector = `#filterResults ul.control-list.${parentId}`;
                }

                $(parentDOMSelector).append(commandTemplate(command));
            }
            thumbPageListUtil.applyBehaviorFilterTreeStyles();
        })
    }

    controlExists(command) {
        let parentDOMSelector = `#filterResults ul.control-list[data-selected-control="${command.behaviorKey === "workflow" ? "workflow" : command.cleanControlId}"]`;
        return $(parentDOMSelector).length > 0;
    }

    behaviorTriggerExists(command) {
        let parentDOMSelector = `#filterResults ul.control-list.${command.cleanOwnerId}-${command.behaviorKey}`;
        return ($(parentDOMSelector)).length > 0;
    }

    generateControls(parentId, controls, includesBehaviors = true) {
        let self = this;
        // get the page ul for inserting controls
        let parentDOMSelector = '#filterResults ul.control-list.' + parentId;
        _.forEach(controls, function (control) {
            // The control could be created before if it was a parent...
            if (!self.isControlCreated(control)) {
                // if not created, let's gonna create it...
                control.isGroup = false;
                control.isFilter = true;
                control.behaviors = thumbPageListUtil.getBehaviorsListForFilter(control.factoryKey, control.id);
                // if I need to create a parent before...
                if (control.isNested) {
                    function findElement(element) {
                        return control.groupId === element.id;
                    }
                    let parent = controls.find(findElement);
                    if (parent) {
                        self.generateControls(parentId, [parent], true);
                    } else {
                        parent = listService.getObject(control.groupId);
                        const factoryName = factoryService.factories[parent.model.get('factoryKey')].name;
                        let controlParent = [{
                            id: parent.model.get('id'),
                            factoryKey: parent.model.get('factoryKey'),
                            icon: parent.model.get('icon'),
                            name: parent.model.get('name'),
                            selectFields: undefined,
                            controls: [],
                            isNested: !!parent.groupId,
                            groupId: parent.groupId ? parent.groupId : null,
                            tooltip: (factoryName) + ' - ' + parent.model.get('name')
                        }];
                        self.generateControls(parentId, controlParent, false);
                    }
                    let checkIfGroupExistsSelector = `#filterResults ul[control-id=${control.groupId}]`;
                    $(checkIfGroupExistsSelector).append(controlTemplate(control));
                    if (includesBehaviors) {
                        self.appendBehaviorsToControl(control);
                        thumbPageListUtil.applyFilterTreeStyles(control.id);
                    }
                } else {
                    $(parentDOMSelector).append(controlTemplate(control));
                    if (includesBehaviors) {
                        self.appendBehaviorsToControl(control);
                        thumbPageListUtil.applyFilterTreeStyles(control.id);
                    }
                }
            }
        });
    }

    appendBehaviorsToControl(control) {
        let lastUnorderedList = $(`#filterResults ul.control-list.${control.id}`);
        lastUnorderedList.append(controlBehaviorsTemplate(control));
        lastUnorderedList.attr('data-group-id', '');
    }

    isGroupCreated(control) {
        let checkIfExistsSelector = `#filterResults ul[data-group-id=${control.groupId}]`;
        return $(checkIfExistsSelector).length > 0
    }

    isControlCreated(control) {
        let checkIfExistsSelector = `#filterResults ul[control-id=${control.id}]`;
        return $(checkIfExistsSelector).length > 0
    }

    render() {

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
    }
}
export default FilterAndSearchView;